import { AUTH_LOGOUT_SUCCESS, LOAD_SUBSCRIPTIONS_REQUEST, LOAD_SUBSCRIPTIONS_SUCCESS, LOAD_SUBSCRIPTIONS_ERROR, LOAD_SUBSCRIPTION_REQUEST, LOAD_SUBSCRIPTION_SUCCESS, LOAD_SUBSCRIPTION_ERROR, CANCEL_SUBSCRIPTION_REQUEST, CANCEL_SUBSCRIPTION_SUCCESS, CANCEL_SUBSCRIPTION_ERROR, SKIP_SUBSCRIPTION_REQUEST, SKIP_SUBSCRIPTION_SUCCESS, SKIP_SUBSCRIPTION_ERROR, UPDATE_SUBSCRIPTION_REQUEST, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_ERROR, RESUME_SUBSCRIPTION_REQUEST, RESUME_SUBSCRIPTION_SUCCESS, RESUME_SUBSCRIPTION_ERROR, PAUSE_SUBSCRIPTION_REQUEST, PAUSE_SUBSCRIPTION_SUCCESS, PAUSE_SUBSCRIPTION_ERROR, } from '../actions/types';
import { addToList, removeFromList, removeFromMap, } from './utils/thunk';
import initialState from '../store/initial-state';
const subscriptions = (
// eslint-disable-next-line default-param-last
state = initialState.subscriptions, action) => {
    switch (action.type) {
        case AUTH_LOGOUT_SUCCESS:
            return {
                data: {},
                loading: [],
                isLoaded: false,
            };
        case LOAD_SUBSCRIPTIONS_REQUEST: {
            return {
                ...state,
                loading: ['list'],
                success: [],
                error: null,
            };
        }
        case LOAD_SUBSCRIPTION_REQUEST:
        case CANCEL_SUBSCRIPTION_REQUEST:
        case SKIP_SUBSCRIPTION_REQUEST:
        case UPDATE_SUBSCRIPTION_REQUEST:
        case RESUME_SUBSCRIPTION_REQUEST:
        case PAUSE_SUBSCRIPTION_REQUEST: {
            return {
                ...state,
                success: removeFromList({
                    list: state.success,
                    key: action.payload,
                }),
                loading: addToList({
                    list: state.loading,
                    key: action.payload,
                }),
                error: removeFromMap({
                    map: state.error,
                    key: action.payload,
                }),
            };
        }
        case LOAD_SUBSCRIPTIONS_SUCCESS: {
            return {
                ...state,
                success: ['list'],
                loading: [],
                data: action.payload.data.reduce((acc, sub) => ({ ...acc, [sub.id]: sub }), {}),
                error: null,
            };
        }
        case LOAD_SUBSCRIPTION_SUCCESS:
        case CANCEL_SUBSCRIPTION_SUCCESS:
        case SKIP_SUBSCRIPTION_SUCCESS:
        case UPDATE_SUBSCRIPTION_SUCCESS:
        case RESUME_SUBSCRIPTION_SUCCESS:
        case PAUSE_SUBSCRIPTION_SUCCESS: {
            const { id } = action.payload.data;
            const newData = {
                ...state.data,
                [id]: action.payload.data,
            };
            return {
                ...state,
                loading: removeFromList({
                    list: state.loading,
                    key: id,
                }),
                success: addToList({
                    list: state.success,
                    key: id,
                }),
                data: newData,
                error: removeFromMap({
                    map: state.error,
                    key: id,
                }),
            };
        }
        case LOAD_SUBSCRIPTIONS_ERROR: {
            return {
                ...state,
                success: [],
                loading: [],
                data: {},
                error: {
                    list: action.payload,
                },
            };
        }
        case LOAD_SUBSCRIPTION_ERROR:
        case CANCEL_SUBSCRIPTION_ERROR:
        case SKIP_SUBSCRIPTION_ERROR:
        case UPDATE_SUBSCRIPTION_ERROR:
        case RESUME_SUBSCRIPTION_ERROR:
        case PAUSE_SUBSCRIPTION_ERROR: {
            const { id, error } = action.payload;
            return {
                ...state,
                loading: removeFromList({
                    list: state.loading,
                    key: id,
                }),
                success: removeFromList({
                    list: state.success,
                    key: id,
                }),
                error: { ...state.error, [id]: error },
            };
        }
        default:
            return state;
    }
};
export default subscriptions;
